import { render } from "./ShipmentsMerchant.vue?vue&type=template&id=63baddfa&scoped=true&ts=true"
import script from "./ShipmentsMerchant.vue?vue&type=script&lang=ts"
export * from "./ShipmentsMerchant.vue?vue&type=script&lang=ts"

import "./ShipmentsMerchant.vue?vue&type=style&index=0&id=63baddfa&scoped=true&lang=css"

import exportComponent from "/var/www/html/lmd-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63baddfa"]])

export default __exports__